import { DecryptedOBJ, EncryptedText, EncryptedOBJ, DecryptedText } from "../utils/Encryption";
import { NhealthAction } from "./action.api";
import useLineLogin from "./authLine/lineLogin";
import lineConfig from "./authLine/lineConfig";
import { Base_API } from "./matcher";

export {
    getMemberLab,
    getMemberNonLab,
    isMembership,
    isMembershipNonLab,
    getJWT
}

const isMembership = () => {
    return new Promise(async resolve => {
        let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
        if(lineProfile !== null)
        {
            NhealthAction.GetMember(lineProfile.user_id)
            .then(async res => {
                console.log('get member: ', res);
                if(res.isSuccess === true)
                {
                    if(res.member.cardid === 0) // no card
                    {
                        resolve(false);
                    }else // done
                    {
                        localStorage.setItem(process.env.REACT_APP_ENC_NAME_USER_PHONE, EncryptedText(res.member.Phoneno))
                        resolve(true);
                    }
                }else
                {
                    if(res.errMessage === "not found !.")
                    {
                        resolve(false);    
                    }
                }
            })
        }else
        {
            localStorage.clear();
            location.href = `${Base_API.pathWeb}/n-health/mycard`
            console.error('Error: Line Profile Is Required! Please Sign-In');
        }
    })
}
const isMembershipNonLab = () => {
    return new Promise(async resolve => {
        let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
        if(lineProfile !== null)
        {
            NhealthAction.GetMemberNonlab(lineProfile.user_id)
            .then(async res => {
                console.log('get member: ', res);
                if(res.isSuccess === true)
                {
                    if(res.member.cardid === 0) // no card
                    {
                        resolve(false);
                    }else // done
                    {
                        localStorage.setItem(process.env.REACT_APP_ENC_NAME_USER_PHONE, EncryptedText(res.member.Phoneno))
                        resolve(true);
                    }
                }else
                {
                    if(res.errMessage === "not found !.")
                    {
                        resolve(false);    
                    }
                }
            })
        }else
        {
            console.error('Error: Line Profile Is Required! Please Sign-In');
        }
    })
}
const getMemberLab = () => {
    return new Promise(async resolve => {
        let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
        console.log('raw line profile: ', localStorage.getItem('line_profile')); 
        console.log('Line Profile: ', lineProfile);

        if(lineProfile !== null)
        {
            NhealthAction.GetMember(lineProfile.user_id)
            .then(async res => {
                if(res.isSuccess === true)
                {
                    if(res.member.cardid === 0) // no card
                    {
                        // goToRegisCard();
                        resolve(null);
                    }else // done
                    {
                        localStorage.setItem(process.env.REACT_APP_ENC_NAME_USER_PHONE, EncryptedText(res.member.Phoneno))
                        resolve(res.member);
                    }
                }else
                {
                    // resolve(lineProfile.user_id);
                    if(res.errMessage === "not found !.")
                    {
                        resolve(null); 
                    }
                }
            })
        }else
        {
            await useLineLogin(lineConfig.packages);
        }
    })
}
const getMemberNonLab = () => {
    return new Promise(async resolve => {
        let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
        console.log('raw line profile: ', localStorage.getItem('line_profile')); 
        console.log('Line Profile: ', lineProfile);

        if(lineProfile !== null)
        {
            NhealthAction.GetMemberNonlab(lineProfile.user_id)
            .then(async res => {
                if(res.isSuccess === true)
                {
                    if(res.member.cardid === 0) // no card
                    {
                        // goToRegisCard();
                        resolve(null);
                    }else // done
                    {
                        localStorage.setItem(process.env.REACT_APP_ENC_NAME_USER_PHONE, EncryptedText(res.member.Phoneno))
                        resolve(res.member);
                    }
                }else
                {
                    // resolve(lineProfile.user_id);
                    if(res.errMessage === "not found !.")
                    {
                        resolve(null); 
                    }
                }
            })
        }else
        {
            await useLineLogin(lineConfig.packages);
        }
    })
}

const getJWT = () => {
    return new Promise(async resolve => {
        let ip = await NhealthAction.GetIPAdress();
        let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
        let udid = lineProfile.user_id;

        if(!!lineProfile)
        {
            let reqData = {
                UserRef: udid,
                IPAddress: ip,
                Channal: process.env.REACT_APP_ENC_NAME_CHANNEL_REF
            } 
            NhealthAction.JWT_Authen(reqData)
            .then(res => {
                if(!!res)
                {
                    localStorage.setItem(process.env.REACT_APP_ENC_NAME_JWT_DATA, EncryptedOBJ(res));
                    resolve(res);
                }
            })
        }else
        {
            console.error('Line profile is required!');
        }
    })
}

const goToRegisCard = () => {
    window.location.href = `${Base_API.pathWeb}/n-health/welcome-card-register`;
}